import { SensitivitySection } from 'components/shared/Sensitivity/SensitivitySection/SensitivitySection';
import type { ReactNode } from 'react';
import { connect } from 'react-redux';
import type { WorkspaceTabOwnProps } from 'shared/connect/connect';
import type { Fee } from 'state/quotes/details/details.model';
import { getQuoteFees } from 'state/selectors/common/commonForm';
import { hasFees } from 'state/selectors/meta/quote/utils';
import type { AppState } from 'state/state.model';
import { getUserPreferencesFeesPrecision } from 'state/userPreferences/userPreferences.selectors';

interface StateProps {
  hasFees: boolean;

  precisionFees?: number;
  fees?: Fee[];
}
interface OwnProps {
  children?: ReactNode;
}

type FeesProps = StateProps & OwnProps;

const mapStateToProps = (state: AppState, { formId, workspace }: WorkspaceTabOwnProps): StateProps => {
  const quoteFees = getQuoteFees(state, workspace, formId);
  return {
    hasFees: hasFees(state, workspace, formId),
    fees: quoteFees,
    precisionFees: getUserPreferencesFeesPrecision(state),
  };
};

export const ConnectedFees = connect(mapStateToProps)(FeesSection);

function FeesSection({ fees, hasFees, precisionFees, children }: FeesProps) {
  if (fees && hasFees) {
    return (
      <SensitivitySection
        sectionName="Fees"
        unavailableDataMessageKey="quoteDetails.NoFeesAvailable"
        copyActionName="Copy Fees"
        data={fees}
        precision={precisionFees ?? 4}
      >
        {children}
      </SensitivitySection>
    );
  }
}
